// @flow
import { connect } from 'react-redux';

import SocialCard from 'components/social/SocialCard';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/social/SocialCard';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(SocialCard);
